import { toUsCurrency } from 'lib';
import Styled from 'styled-components';

function DepositAverage(props) {
    const { month, totalDeposit, averageDeposit } = props;

    return (
        <Wrapper>
            <h1>{month} Months Average</h1>
            <p>
                <span>Total Deposits</span>
                <strong>{toUsCurrency(totalDeposit)}</strong>
            </p>
            <p>
                <span>Average Monthly Deposits</span>
                <strong>{toUsCurrency(averageDeposit)}</strong>
            </p>
        </Wrapper>
    );
}

const Wrapper = Styled.div`
    h1 {
        font-size: 12px;
        line-height: 18px;
        font-weight: 600;
        color: #008AC8;
        margin: 0;
        padding: 0;
    }
    p {
        font-size: 12px;
        line-height: 19px;
        color: #0F212E;
        display: flex;
        justify-content: space-between;
        margin: 0;
        padding: 4px 0 0 0;
    }
`;
export default DepositAverage;
